<script lang="ts">
	import StyleCard from '$lib/components/StyleCard.svelte';
	import InputControl from '$lib/components/forms/InputControl.svelte';
	import type { Style } from '$lib/types';
	import { X } from 'lucide-svelte';
	import { createEventDispatcher } from 'svelte';
	import { Doc } from 'sveltefire';

	export let styles: Style[];

	// Style selection state management
	const dispatch = createEventDispatcher();
	export let style: Style | undefined = undefined;
	function selectStyle(c: Style) {
		style = c;
		dispatch('selectStyle', { style });
		toggleModal();
	}
	function handleClearStyle() {
		style = undefined;
		dispatch('clearStyle');
	}

	// Modal state management
	let showModal = false;
	let dialog: HTMLDialogElement;
	function toggleModal() {
		if (dialog) {
			if (showModal) {
				dialog.close();
				showModal = false;
			} else {
				dialog.showModal();
				showModal = true;
			}
		}
	}
	$: if (dialog && showModal) dialog.showModal();
</script>

<InputControl
	label={styles.length <= 0 ? 'Create a Style' : 'Select a Style'}
	sublabel={styles.length <= 0
		? "Upload a few photos of your loved one, and we'll create an illustrated version of them as a style."
		: 'Choose a style to place in your image.'}>
	{#key style}
		{#if !style}
			<button class="btn btn-ghost text-accent" type="button" on:click|preventDefault={toggleModal}>
				<span>No style selected - click to select</span>
			</button>
		{:else}
			<div
				class="flex-start flex h-20 w-full items-center justify-start gap-4 rounded-lg p-2 text-left font-normal">
				<div class="w-12 flex-none">
					<Doc ref="images/{style.image}" let:data={c}>
						<img src={c.src} alt={style.title} class="h-12 w-12 rounded-full" />
					</Doc>
				</div>
				<div class="flex-grow">
					<div class="flex items-center justify-between">
						<span class="font-story text-lg">{style.title}</span>
						<button
							type="button"
							class="btn-large badge btn btn-ghost text-error"
							on:click|preventDefault={handleClearStyle}>
							<X /> Clear style
						</button>
					</div>
				</div>
			</div>
		{/if}
	{/key}
</InputControl>

<dialog class="modal modal-bottom sm:modal-middle" bind:this={dialog}>
	<div class="modal-box">
		<div>
			{#if styles.length <= 0}
				<p class="mb-8 font-bold">Create a Style</p>
				<p class="mb-8 text-stone-500">
					Upload a few photos of your loved one, and we'll create an illustrated version of them as
					a style.
				</p>
			{:else}
				<p class="mb-8 font-bold">Select a Style</p>
			{/if}
			{#each styles as style (style.uid)}
				<button
					type="button"
					on:click|preventDefault={() => {
						selectStyle(style);
					}}
					class="flex-start flex h-20 w-full items-center justify-start gap-4 rounded-lg p-2 text-left font-normal hover:bg-base-200">
					<StyleCard {style} />
				</button>
			{/each}
		</div>
	</div>

	<form method="dialog" class="modal-backdrop">
		<button on:click|preventDefault={toggleModal}>Close</button>
	</form>
</dialog>
